import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#03A9F4',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    btnColor: '#03A9F4',
    sectionColor: '#FAFAFA',
    engageColor: '#FF0000',
    toolbarColor: '#fff',
    error: '#b71c1c'
  }
})
